"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpentrackOperationCodeEntity = void 0;
const BadRequestError_1 = require("../GS/BadRequestError");
const validators_1 = require("../GS/validators");
const OpentrackOperationCodeDto_1 = require("./OpentrackOperationCodeDto");
const SingleEntityBase_1 = require("../GS/SingleEntityBase");
const ValidationError_1 = require("../GS/ValidationError");
class OpentrackOperationCodeEntity extends SingleEntityBase_1.SingleEntityBase {
    constructor(dependencies, opentrackOperationCode) {
        super();
        this._requiredFieldsSetStatus = {
            enterpriseCode: false,
            companyNumber: false,
            operationCode: false
        };
        this._dependencies = dependencies;
        if (opentrackOperationCode === undefined) {
            this._dto = new OpentrackOperationCodeDto_1.OpentrackOperationCodeDto();
        }
        else if (opentrackOperationCode instanceof OpentrackOperationCodeDto_1.OpentrackOperationCodeDto) {
            this._dto = new OpentrackOperationCodeDto_1.OpentrackOperationCodeDto(opentrackOperationCode);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else if (opentrackOperationCode instanceof OpentrackOperationCodeEntity) {
            this._dto = new OpentrackOperationCodeDto_1.OpentrackOperationCodeDto(opentrackOperationCode._dto);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else {
            throw new Error("Invalid arg");
        }
    }
    toDto() {
        return new OpentrackOperationCodeDto_1.OpentrackOperationCodeDto(this._dto);
    }
    getId() {
        return this._dto.id;
    }
    getEnterpriseCode() {
        return this._dto.enterpriseCode;
    }
    setEnterpriseCode(untrustedValue) {
        const maxLength = 20;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("enterpriseCode");
        this._requiredFieldsSetStatus.enterpriseCode = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("enterpriseCode", "Enterprise Code is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("enterpriseCode", `Enterprise Code has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.enterpriseCode) {
            return;
        }
        this._dto.enterpriseCode = _untrustedValue;
        this._setIsDirty(true);
    }
    getCompanyNumber() {
        return this._dto.companyNumber;
    }
    setCompanyNumber(untrustedValue) {
        const maxLength = 20;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("companyNumber");
        this._requiredFieldsSetStatus.companyNumber = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("companyNumber", "Company Number is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("companyNumber", `Company Number has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.companyNumber) {
            return;
        }
        this._dto.companyNumber = _untrustedValue;
        this._setIsDirty(true);
    }
    getOperationCode() {
        return this._dto.operationCode;
    }
    setOperationCode(untrustedValue) {
        const maxLength = 20;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("operationCode");
        this._requiredFieldsSetStatus.operationCode = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("operationCode", "Operation Code is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("operationCode", `Operation Code has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.operationCode) {
            return;
        }
        this._dto.operationCode = _untrustedValue;
        this._setIsDirty(true);
    }
    getDescription() {
        return this._dto.description;
    }
    setDescription(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("description");
        if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("description", `Description has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.description) {
            return;
        }
        this._dto.description = _untrustedValue;
        this._setIsDirty(true);
    }
    loadAsync(id) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (typeof id === "string") {
                    if (!validators_1.isInt(id, { min: 1 })) {
                        throw new BadRequestError_1.BadRequestError("ID is not valid.");
                    }
                    id = parseInt(id, 10);
                }
                this._setState("busy");
                this._emit("before-loadAsync");
                this._dto = yield this._dependencies.opentrackOperationCodeDatastore
                    .getAsync(id);
                this._setIsNew(false);
                this._setIsDirty(false);
                this._clearAllRequiredFieldsSetStatuses();
                this.clearErrors();
                this._emit("after-loadAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    saveAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-saveAsync");
                if (!this.allRequiredFieldsSet) {
                    const fields = Object.entries(this._requiredFieldsSetStatus)
                        .filter(([, isSet]) => !isSet).map(([field]) => field);
                    throw new Error(`The following required fields were never set: ${fields.join(", ")}`);
                }
                if (!this.canSave) {
                    throw new Error("Opentrack Operation Code is not in a valid state.");
                }
                let dto = this.toDto();
                if (this.isNew) {
                    dto = yield this._dependencies.opentrackOperationCodeDatastore
                        .addAsync(this._dto);
                }
                else if (this.isDirty) {
                    dto = yield this._dependencies.opentrackOperationCodeDatastore
                        .updateAsync(this._dto);
                }
                this._dto.id = dto.id;
                this._setIsNew(false);
                this._setIsDirty(false);
                this._emit("after-saveAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    deleteAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-deleteAsync");
                if (!this.canDelete) {
                    throw new Error("Opentrack Operation Code cannot be deleted.");
                }
                if (!this.isNew) {
                    yield this._dependencies.opentrackOperationCodeDatastore
                        .removeAsync(this.getId());
                }
                this._emit("after-deleteAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
}
exports.OpentrackOperationCodeEntity = OpentrackOperationCodeEntity;
//# sourceMappingURL=OpentrackOperationCodeEntity.js.map